module.exports = __webpack_public_path__ + "static/media/list-pdf.ffc186db.svg";